/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AiOfferBatch from './AiOfferBatch';

/**
 * The AiOfferBatchesResponse model module.
 * @module model/AiOfferBatchesResponse
 * @version 1.0.0
 */
class AiOfferBatchesResponse {
    /**
     * Constructs a new <code>AiOfferBatchesResponse</code>.
     * @alias module:model/AiOfferBatchesResponse
     */
    constructor() { 
        
        AiOfferBatchesResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AiOfferBatchesResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AiOfferBatchesResponse} obj Optional instance to populate.
     * @return {module:model/AiOfferBatchesResponse} The populated <code>AiOfferBatchesResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AiOfferBatchesResponse();

            if (data.hasOwnProperty('batches')) {
                obj['batches'] = ApiClient.convertToType(data['batches'], [AiOfferBatch]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AiOfferBatchesResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AiOfferBatchesResponse</code>.
     */
    static validateJSON(data) {
        if (data['batches']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['batches'])) {
                throw new Error("Expected the field `batches` to be an array in the JSON data but got " + data['batches']);
            }
            // validate the optional field `batches` (array)
            for (const item of data['batches']) {
                AiOfferBatch.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Array.<module:model/AiOfferBatch>} batches
 */
AiOfferBatchesResponse.prototype['batches'] = undefined;






export default AiOfferBatchesResponse;

